export default {
  features: {
    applicationCompletion: {
      sendSms: "Muddatli to'lovni tasdiqlash uchun sms-kodni yuborish.",
      warnings: ['Tasdiqlangandan so‘ng rassrokani bekor qilib bo‘lmaydi', 'Endi siz Alifning ishonchli vakilisiz'],
      checkboxLabel: 'Sotuvchi Alif Moliya uchun mahsulot(lar)ni ajratdi va topshirdi',
      smsWasSent: 'SMS-kod mijoz raqamiga yuborildi',
      fields: {
        code: {
          label: 'SMSdagi kod',
        },
      },
      request: 'Rasmiylashtirish',
      confirm: 'Tasdiqlash',
      cancel: 'Bekor qilish',
    },
  },
};
